import styled from 'styled-components';

export const PopupStyle = styled.div.attrs(props => ({
    className: props.className,
}))`
    background-color: var(--color-bg-shades);
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1010;
    overflow-y: scroll;
    opacity: 0;
    visibility: hidden;
    transition: all .3s ease;

    &.open {
        opacity: 1;
        visibility: visible;
    }

    & .pp-loader {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1005;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: var(--color-bg-shades3);
        visibility: hidden;
        opacity: 0;

        &.active {
            visibility: visible;
            opacity: 1;
        }

        & div {
            width: 40px;
            height: 40px;
            border: 4px solid var(--color-primary-dark);
            border-right: 3px solid transparent;
            border-radius: 50%;
            animation: spin 2s linear infinite;
        }
    }

    & .pp-details {
        max-width: 1350px;
        width: calc(85% + 30px);
        margin: auto;
        max-height: 0;
        overflow: hidden;
        opacity: 0;
        transition: all .5s ease;

        &.active {
            opacity: 1;
        }


        & .pp-details-inner {
            padding: 30px 0;

            & .pp-title {
                padding: 0 15px;

                & h2 {
                    font-size: 2.8rem;
                    color: var(--color-text3);
                    font-weight: 600;
                    text-transform: capitalize;
                    margin: 0 0 5px;
                }

                & p {
                    font-size: 1.4rem;
                    font-weight: 600;
                    color: var(--color-text2);
                    margin: 0 0 15px;
                    border-bottom: 1px solid var(--color-bg-shades2);
                    padding-bottom: 10px;

                    & span {
                        font-weight: 400;
                        text-transform: capitalize;
                    }
                }
            }

            & .pp-project-details {
                
                & h3 {
                    font-size: 2rem;
                    font-weight: 600;
                    color: var(--color-text2);
                    margin: 0 0 15px;
                    text-transform: capitalize;
                }

                & .description {
                    flex: 0 0 65%;
                    max-width: 65%;
                    padding: 0 15px;

                    & p {
                        font-size: 1.6rem;
                        color: var(--color-text2);
                        line-height: 2.6rem;
                        margin: 0;

                        & span {
                            font-weight: 400;
                            text-transform: capitalize;
                        }
                    }
                }

                & .info {
                    flex: 0 0 35%;
                    max-width: 35%;
                    padding: 0 15px;

                    & ul li {
                        display: block;
                        font-size: 1.6rem;
                        font-weight: 600;
                        color: var(--color-text2);

                        & span {
                            font-weight: 400;

                            & a {
                                display: inline-block;
                                color: var(--color-primary-dark);

                                &:not(:last-child) {
                                    margin-right: 1rem;
                                }
                            }
                        }
                    }

                    & ul li:not(:last-child) {
                        margin-bottom: 10px;
                    }
                }
            }
        }
    }

    & .pp-separator {
        height: 1px;
        width: 100%;
        display: block;
        background-color: var(--color-bg-shades2);
    }

    & .pp-main {
        min-height: 100vh;
        max-width: 1350px;
        width: 85%;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;

        & .pp__main--inner {
            padding: 70px 0 50px;
            position: relative;

            & .pp-project__details--btn {
                position: absolute;
                left: 0;
                top: 15px;
                height: 40px;
                line-height: 40px;
                border-radius: 30px;
                font-size: 1.6rem;
                font-weight: 500;
                color: var(--color-primary-dark);
                cursor: pointer;
                padding: 0 15px;
                transition: all .3s ease;

                & svg{
                    margin-left: 4px;
                    display: inline-block;
                }

                &::after {
                    border-radius: 30px;
                }
            }

            & .pp-close {
                position: absolute;
                right: 0;
                border-radius: 50%;
                width: 40px;
                height: 40px;
                top: 15px;
                text-align: center;
                font-size: 3.5rem;
                line-height: 3.5rem;
                color: var(--color-text2);
                cursor: pointer;
                transition:  all .3s ease;

                &::after {
                    border-radius: 50%;
                }
            }

            & .pp-counter {
                position: absolute;
                right: 0;
                bottom: 5px;
                height: 40px;
                line-height: 40px;
                font-size: 1.6rem;
                color: var(--color-text2);
            }

            & .pp__img {
                max-width: 100%;
                height: auto;
                margin: auto;
                padding: 10px;
                border-radius: 5px;
            }
        }

        & .pp-prev,
        & .pp-next {
            position: fixed;
            top: 50%;
            height: 40px;
            width: 40px;
            text-align: center;
            font-size: 2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            z-index: 1010;
            color: var(--color-text3);
            transition: all .3s ease;
            opacity: .5;

            & svg {
                display: inline-block;
                
            }

            &:hover {
                opacity: 1;
            }
        }

        & .pp-prev {
            left: 15px;

            & svg {
                transform: rotate(180deg);
            }
        }

        & .pp-next {
            right: 15px;
        }
    }
`;